import React from 'react';
import * as S from './GrowBusiness.styles';

const GrowBusiness = ({timeZone, lob}) => {
  return (
    <S.GrowMainWrap>
      <S.SliderCaroWrap>
        {!timeZone ? (
          <S.SliderInnerWrap>
            {!lob ? (
              <S.SlideWrap>
                <S.GrowHeadText>
                  The Smart Way to <br />
                  <span>Grow Your Business</span>
                </S.GrowHeadText>
                <S.GrowSubText>
                  Welcome to myPartner, a platform built exclusively for travel agents to fulfill
                  all their customer travel needs with easy-to-use features and amazing deals.
                </S.GrowSubText>
              </S.SlideWrap>
            ) : null}
            {lob === 'flight' ? (
              <S.SlideWrap>
                <S.GrowHeadText>
                  The Smart Way to <br />
                  Book Flights
                </S.GrowHeadText>
                <S.GrowSubText>
                  Get access to 300+ airline carriers and maximize your earnings with the best
                  deals, cool promotional discounts and easy post-booking modifications.
                </S.GrowSubText>
              </S.SlideWrap>
            ) : null}
            {lob === 'hotel' ? (
              <S.SlideWrap>
                <S.GrowHeadText>
                  The Smart Way to <br />
                  Book Hotels
                </S.GrowHeadText>
                <S.GrowSubText>
                  Get access to the largest inventory of 8 lacs+ domestic and international hotels &
                  homestays at the best ever rates, and deliver impeccable customer service with
                  best-in-class cancellation policies.
                </S.GrowSubText>
              </S.SlideWrap>
            ) : null}
          </S.SliderInnerWrap>
        ) : (
          <S.SlideWrapUae>
            <S.GrowHeadText>
              The Smart Way to <br />
              Book Flights
            </S.GrowHeadText>
            <S.GrowSubText>
              Get access to 300+ airline carriers and maximize your earnings with the best deals,
              cool promotional discounts and easy post-booking modifications.
            </S.GrowSubText>
          </S.SlideWrapUae>
        )}
      </S.SliderCaroWrap>

      <S.GrowTileWrap>
        <S.GrowTile>
          <S.TileCircle>
            <span />
          </S.TileCircle>
          <S.GrowTileText>
            Get the Best Deals on <span>Flights</span>
          </S.GrowTileText>
        </S.GrowTile>
        <S.GrowTile>
          <S.TileCircle>
            <span />
          </S.TileCircle>
          {timeZone ? (
            <S.GrowTileText>
              Access to <span>300+ carriers</span>
            </S.GrowTileText>
          ) : (
            <S.GrowTileText>
              Book from the Widest Range of <span>Hotels</span>
            </S.GrowTileText>
          )}
        </S.GrowTile>
      </S.GrowTileWrap>
      {!timeZone ? (
        <S.GrowScrollWrap>
          <S.GrowScrollBig>
            <span />
          </S.GrowScrollBig>
          <S.GrowScroll></S.GrowScroll>
          <S.GrowScroll></S.GrowScroll>
        </S.GrowScrollWrap>
      ) : (
        <></>
      )}
    </S.GrowMainWrap>
  );
};

export default GrowBusiness;
